import React from 'react'
import { styled } from '../styled'
import { Box, BoxProps } from '../atoms'

interface VideoEmbedProps extends BoxProps {
  video?: string
}

const DesktopIframe = styled.iframe`
  margin: -64px 0;
  width: 100%;
  height: calc(100% + 128px);
  overflow: hidden;
  pointer-events: none;
`

const MobileIframe = styled.iframe`
  margin: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
`

export const VideoEmbed = ({ video, ...props }: VideoEmbedProps) => {
  if (typeof window === 'undefined') {
    return (
      <MobileIframe
        frameBorder="0"
        src={`https://www.youtube.com/embed/${video}?loop=1&playlist=${video}&iv_load_policy=3&modestbranding=1&autoplay=1&controls=0&showinfo=0&wmode=opaque&branding=0&autohide=0`}
      />
    )
  }

  return (
    <Box {...props} overflow="hidden">
      {isMobileDevice() ? (
        <MobileIframe
          frameBorder="0"
          src={`https://www.youtube.com/embed/${video}?loop=1
          &playlist=${video}&iv_load_policy=3&modestbranding=1&autoplay=1&controls=0&showinfo=0&wmode=opaque&branding=0&autohide=0`}
        />
      ) : (
        <DesktopIframe
          frameBorder="0"
          src={`https://www.youtube.com/embed/${video}?loop=1&playlist=${video}&iv_load_policy=3&modestbranding=1&autoplay=1&controls=0&showinfo=0&wmode=opaque&branding=0&autohide=0&mute=true&rel=0&start=9&enablejsapi=1&origin=http%3A%2F%2Flocalhost%3A6006&widgetid=1`}
        />
      )}
    </Box>
  )
}

function isMobileDevice() {
  return (
    typeof window.orientation !== 'undefined' ||
    navigator.userAgent.indexOf('IEMobile') !== -1
  )
}
